export const previousRoute = {
	data() {
		return {
			previousRoute: []
		};
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.previousRoute = from;

			next();
		});
	}
};